import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import Layout from './layout'
import EditListingForm from './form-edit'
import SidebarLinks from './form-edit/sidebar-links'
import { useLoadListingLandlords } from './hooks/use-load-listing-landlords'
import useParamsLoadListing from './hooks/use-parms-load-listing'

const ListingEdit = () => {
  const { t } = useTranslation()
  const { listing, listingId, isLoading: isListingLoading } = useParamsLoadListing()
  const { landlords, isLoading: isLandlordsLoading } = useLoadListingLandlords(listingId)

  const isLoading = isListingLoading || isLandlordsLoading

  const sectionRefs = {
    information: useRef<HTMLDivElement>(null),
    terms: useRef<HTMLDivElement>(null),
    features: useRef<HTMLDivElement>(null),
    photo: useRef<HTMLDivElement>(null),
    video: useRef<HTMLDivElement>(null),
    tour: useRef<HTMLDivElement>(null),
    landlords: useRef<HTMLDivElement>(null)
  }

  return (
    <Layout
      data={listing}
      metaTitle={t('Edit Listing', 'Edit Listing')}
      sidebarComponent={<SidebarLinks isLoading={isLoading} refs={sectionRefs} />}
    >
      <EditListingForm
        data={listing}
        landlordData={landlords}
        isLoading={isLoading}
        refs={sectionRefs}
      />
    </Layout>
  )
}

export default ListingEdit
